import { TextCaption } from '@/design-system/components/typography';
import { SxProp, View } from 'dripsy';
import { t } from 'i18next';
import React from 'react';
import { getEarnTypeTranslationKey } from '../../utils/getEarnTypeTranslationKey';
import { getSubscriptionTypeTagColours } from '../../utils/getSubscriptionTypeTagColours';

interface ActivityActionTagProps {
  action: string;
  sx?: SxProp;
}

export const ActivityActionTag: React.FC<ActivityActionTagProps> = ({ action }) => {
  const itemColour = getSubscriptionTypeTagColours(action);

  return (
    <View sx={{ width: 'auto', paddingY: 2, paddingX: '$2', borderRadius: 100, backgroundColor: itemColour.backgroundColor }}>
      <TextCaption sx={{ color: itemColour.color }}>{t(getEarnTypeTranslationKey(action))}</TextCaption>
    </View>
  );
};
